<template>
  <el-dialog :title="title"
             :close-on-click-modal="false"
             width="650px"
             @closed="close"
             :visible.sync="visible">
    <el-form ref="form"
             :model="form"
             :rules="formRules"
             size="medium"
             label-width="140px"
             @submit.native.prevent="onSubmit()">
      <div class="re-el-form__flex">
        <div class="medium">
          <el-form-item label="项目" prop="projectid">
            <remote-select
              v-model="form.projectid"
              placeholder="请输入项目名称/编号搜索"
              clearable
              class="width-max"
              id-key="number"
              label-key="name"
              value-key="id"
              :query-request="getProjectTable"
              :query-params="{ status: 30 }"
              :find-request="getProjectDetail"
              @change="handleProjectChange">
            </remote-select>
          </el-form-item>
          <el-form-item label="项目目标值周期"
                        prop="dateRange">
            <el-date-picker
              v-model="form.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              class="width-max"
              clearable>
            </el-date-picker>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="close()">取消</el-button>
      <el-button type="primary"
                 @click="onSubmit()">提交
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import RemoteSelect from '@core/components/RemoteSelect'

export default {
  components: {
    RemoteSelect,
  },
  data () {
    return {
      visible: false,
      projectInfo: {
        projectId: null,
        projectNumber: '',
        projectName: '',
      },
      formRules: {
        projectid: [
          {required: true, message: '请选择项目', trigger: 'change'},
        ],
        dateRange: [
          {required: true, message: '请选择项目目标值周期', trigger: 'change'},
        ],
      },
      form: {
        projectid: null,
        dateRange: null,
        start_date: null,
        end_date: null,
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
    }),
    title () {
      return '新增目标配置'
    },
  },
  watch: {
    'form.dateRange' (val) {
      if (val && val.length === 2) {
        this.form.start_date = val[0] + ' 00:00:00'
        this.form.end_date = val[1] + ' 00:00:00'
      } else {
        this.form.start_date = null
        this.form.end_date = null
      }
    },
  },
  methods: {
    /**
     * 获取项目列表（用于 RemoteSelect）
     */
    getProjectTable (params) {
      return request('getBaiscProjectTable', params)
    },
    /**
     * 获取项目详情（用于 RemoteSelect）
     */
    getProjectDetail (params) {
      return request('getProjectDetail', params)
    },
    /**
     * 项目选择变化时，获取项目详情
     */
    handleProjectChange (projectId) {
      if (projectId) {
        this.projectInfo.projectId = projectId
        this.fetchProjectDetail()
      } else {
        this.projectInfo.projectId = null
        this.projectInfo.projectNumber = ''
        this.projectInfo.projectName = ''
      }
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.create(this.form)
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    async create (params) {
      try {
        // 根据ID获取项目详情
        const {data} = await request.common('getProjectDetail', {id: params.projectid})

        const submitData = {
          projectid: data.id,
          customerid: data.customerid,
          projectname: data.name,
          project_leader: data.project_master || '暂未配置',
          start_date: params.start_date,
          end_date: params.end_date,
          creator: this.user.name || this.user.username || '',
        }

        await request.common('createTargetSetting', submitData)
        this.$message.success('创建成功')
        this.$emit('submitted')
        this.close()
      } catch (error) {
        // 错误处理
        console.error('创建失败:', error)
      }
    },
    show (projectIdOrPayload) {
      Object.assign(this.$data, this.$options.data.call(this))
      const projectId = typeof projectIdOrPayload === 'object' && projectIdOrPayload != null
        ? projectIdOrPayload.projectId
        : projectIdOrPayload
      this.projectInfo.projectId = projectId != null ? projectId : null
      this.form.projectid = this.projectInfo.projectId
      this.visible = true
      if (this.projectInfo.projectId) {
        this.fetchProjectDetail()
      }
    },
    fetchProjectDetail () {
      request.common('getProjectDetail', {id: this.projectInfo.projectId})
        .then(({data}) => {
          this.projectInfo.projectNumber = data.number || ''
          this.projectInfo.projectName = data.name || ''
        })
        .catch(e => {
          console.error('获取项目详情失败:', e)
        })
    },
    close () {
      this.visible = false
      if (this.$refs['form']) {
        this.$refs['form'].clearValidate && this.$refs['form'].clearValidate()
        this.$refs['form'].resetFields && this.$refs['form'].resetFields()
      }
      Object.assign(this.$data, this.$options.data.call(this))
    },
  },
}
</script>

<style lang="scss"
       scoped>
.form-readonly {
  color: #606266;
}
</style>




// WEBPACK FOOTER //
// src/views/order-review-target-management/components/TargetSettingFormDialog.vue